import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchPaymentPackages = async () => {
  const { data } = await axios.get(`${API}/payments/packages`);
  return data;
};

export const stripeCheckout = async (package_id, origin_url) => {
  const { data } = await axios.post(`${API}/payments/stripe/checkout`, { package_id, origin_url });
  return data;
};

export const stripeStatus = async (session_id) => {
  const { data } = await axios.get(`${API}/payments/stripe/status/${session_id}`);
  return data;
};

export const submitZelle = async (payload) => {
  const { data } = await axios.post(`${API}/payments/zelle/submit`, payload);
  return data;
};

export const myTransactions = async () => {
  const { data } = await axios.get(`${API}/payments/my-transactions`);
  return data;
};

// Admin
export const adminPendingPayments = async (status) => {
  const params = status ? { status } : {};
  const { data } = await axios.get(`${API}/payments/admin/pending`, { params });
  return data;
};

export const adminApprovePayment = async (tx_id) => {
  const { data } = await axios.post(`${API}/payments/admin/${tx_id}/approve`);
  return data;
};

export const adminRejectPayment = async (tx_id) => {
  const { data } = await axios.post(`${API}/payments/admin/${tx_id}/reject`);
  return data;
};
